import { Component, OnInit, EventEmitter, Output, ViewChild } from '@angular/core';
import { RelationshipService } from '../../shared/services/relationship.service';
import { FormBuilder } from '@angular/forms';
import { Config } from '../../shared/config';
import {
  IColumnHeader, IRelationshipView, IRelationshipMain,
  IRelationshipCodeLineItems
} from '../../shared/models/relationship';
import { Router } from '@angular/router';
import { FrameworkService } from 'gadoe-framework';
import { GridComponent } from '@progress/kendo-angular-grid';
import { IWFObjectType, IObjectStatus, IApplicationRoles, ISearch } from 'src/app/shared/models/common';
import { CommonService } from 'src/app/shared/services/common.service';
import { saveAs } from '@progress/kendo-file-saver';
import { Workbook } from '@progress/kendo-angular-excel-export';
import { observable } from 'rxjs';
@Component({
  selector: 'app-relationship',
  templateUrl: './relationship.component.html',
  styles: [`
 .newStyle {
     background-color: #1CA979 !important;
     color: #ffffff !important;
     font-family: Arial!important;
    font-size: 20%!important;
 }
`
  ],
  providers: [RelationshipService]
})
export class RelationshipComponent implements OnInit {

  mcode = '';
  status: number;
  mappingcode = 0;
  dcode = ''; data: boolean;
  counts: any;
  cols: any[]; loading: boolean;
  opened = false;
  mainCode = ''; showDescription: string;
  mappingDetailsGrid: IRelationshipCodeLineItems[] = [];
  mappedGriddata: IRelationshipCodeLineItems[] = [];
  selectedval: any;
  columnHeaderName: any;
  public expandBtnText: 'Expand All' | 'Collapse All' = 'Expand All';
  expandflag: boolean;
  active = false; Objectstatus: IObjectStatus[];
  relationshipCodeLineItems: IRelationshipCodeLineItems[] = [];
  headerGrid: IRelationshipCodeLineItems[] = [];
  mappingTable: IRelationshipMain[] = [];
  availableTable: IRelationshipMain[] = [];
  InputRelationship: IColumnHeader;
  countsExtended: any;
  roleID: number;
  itroleID: number;
  // readMore: string;  readLess: string;
  showPanel: boolean;
  //  @ViewChild(TooltipDirective)
  //  public tooltipDir: TooltipDirective;
  @ViewChild('mainheaderGrid') mainheaderGrid: GridComponent;
  columnheaders: IColumnHeader[] = [];
  public isCollapsed: boolean;
  public isCollapsable: boolean;

 
  // columnhead: IColumnHeader = { columnHeaderID: 0, name: ''};
  defaultColumnHeader: IColumnHeader = { columnHeaderID: -1, name: 'Select' };
  // @ViewChild(TooltipDirective)  public tooltipDir: TooltipDirective;
  @Output() selectedItem: EventEmitter<IColumnHeader> = new EventEmitter<IColumnHeader>();
  model: ISearch;

  constructor(private frmbuilder: FormBuilder,
    private frameworkService: FrameworkService, private commonService: CommonService,
    private dataService: RelationshipService, private route: Router) { }

  ngOnInit() {
    Config.selectedTab = 1;
    this.modelInit();
    this.refreshtoolbar();
  }
  modelInit() {
    this.model = {
      fiscalYear: -1,
      fiscalYearConfigID: -1,
      columnHeaderID: -1,
      groupclassificationID: 0,
      groupclassificationName: '',
      groupHeaderID: 0,
      name: ''
    };
    this.loading = false;
    this.data = true;
    this.status = 0;
    this.isCollapsed = true;
    this.roleID = Config.userProfile.itApplicationRoleID;
    this.itroleID = IApplicationRoles.Administrator;
    this.isCollapsable = false;
  }

  refreshtoolbar() {
    this.frameworkService.refreshToolBarItems(
      {
        controlID: Config.selectedTabMenuItem.controlID
        , roleID: Config.selectedTabMenuItem.itApplicationRoleID
        , statusID: Config.StatusID
      });
  }
  searchValues(event: IRelationshipView) {
    this.InputRelationship = event;
    if (event.columnHeaderID === -1) {
      this.mcode = ' ';
      this.data = true;
    } else {
      this.data = false;
      this.mcode = event.name.split('-')[0];
      this.dcode = event.name.split('-')[1];
    }
    this.model.fiscalYearConfigID = Config.fiscalYearConfigID;
    this.model.fiscalYear = Config.fiscalYear;
    this.model.columnHeaderID = event.columnHeaderID;
    this.status = Config.StatusID;
    this.getstatus();
    this.getHeaderGrid();
    this.onClickExpand('Collapse All');


  }
  getstatus() {
    this.commonService.GetObjectStatus(Config.fiscalYearConfigID, IWFObjectType.COA)
      .subscribe((response: IObjectStatus[]) => {
        this.Objectstatus = response;
        if (response.length !== 0) {
          this.status = Config.StatusID = this.Objectstatus[0].statusID;
        }
        this.frameworkService.hideSpinner();
        this.refreshtoolbar();
      },
        (err: any) => {
          this.frameworkService.logError(err),

            this.frameworkService.hideSpinner();
        },
        () => this.frameworkService.logInfo('getstatus() retrieved systems'));
  }
  onClickFilter(event) {
    event.filterable = !event.filterable;
  }
  OnClickPublish(event) {
    let varMessage = '';
    let varHeader = '';
    let buttonTypeText = '';
    varMessage = 'Are you sure you want to Publish the <b>' + this.mcode + '-' +
      this.dcode + '</b>  Relationship for <b>' + this.mcode + ' code : ' + event.mCode + '</b> ?';
    varHeader = 'Publish Confirmation';
    buttonTypeText = 'Publish';
    this.mappingTable = this.relationshipCodeLineItems.filter(c => c.mCodeID === event.mCodeID && c.code !== null);
    this.frameworkService.showConfirmDialog({
      message: varMessage,
      header: varHeader,
      icon: 'pi pi-info-circle',
      accept: (comments) => {
        this.frameworkService.showSpinner();
        this.dataService.Publish(this.mappingTable, Config.userProfile.personID, Config.fiscalYearConfigID)
          .subscribe((response: IObjectStatus[]) => {
            this.Objectstatus = response;
            this.getHeaderGrid();
            this.frameworkService.hideSpinner();
            this.frameworkService.showSuccessMessage('Published successfully');

          });
        this.frameworkService.hideSpinner();
      },
      reject: () => {
        this.frameworkService.hideSpinner();
        this.frameworkService.showInfoMessage('Published canceled');
      }
    });
  }
  getHeaderGrid() {
    this.loading = true;
    this.frameworkService.showSpinner();
    this.dataService.getMainMappingCodes(this.model.fiscalYearConfigID, this.model.columnHeaderID, Config.checkPublish)
      .subscribe((response: IRelationshipCodeLineItems[]) => {
        if (response.length !== 0 && response[0].mCode !== null) {
          this.relationshipCodeLineItems = response;
          this.frameworkService.hideSpinner();
          this.loading = false;
          this.headerGrid = [];
          this.counts = this.relationshipCodeLineItems.reduce((p, c) => {
            if (!p.hasOwnProperty(c.mCode)) {
              p[c.mCode] = 0;
              this.headerGrid.push(c);
            }
            p[c.mCode]++;
            return p;
          }, {});
          this.mappingDetailsGrid = this.relationshipCodeLineItems.filter(c => c.name !== null);
        } else {
          this.loading = false;
          this.frameworkService.hideSpinner();
          this.headerGrid = [];
          this.mappingDetailsGrid = null;
        }
      },
        (err: any) => {
          this.frameworkService.logError(err),
            this.loading = false;
          this.frameworkService.hideSpinner();
        },
        () => this.frameworkService.logInfo('getMainGrid() retrieved getMainGrid'));

  }
  public editHandler(event) {
    this.mappingcode = event.dataItem.mCodeID;
    this.frameworkService.showSpinner();
    this.mappingTable = this.relationshipCodeLineItems.filter(c => c.mCodeID === event.dataItem.mCodeID && c.code !== null);
    this.dataService.getAvailableMappingCodes(this.model.fiscalYearConfigID, this.model.columnHeaderID, event.dataItem.mCodeID)
      .subscribe((response: IRelationshipMain[]) => {
        this.availableTable = response;
        this.frameworkService.hideSpinner();

      },
        (err: any) => this.frameworkService.logError(err),
        () => this.frameworkService.logInfo('getMainGrid() retrieved availableTable'));
    this.active = true;
    this.frameworkService.hideSpinner();
    this.mainCode = event.dataItem.mCode + ' - ' + event.dataItem.mName;
  }

  cancelHandler() {
    this.mappingTable = [];
    this.availableTable = [];
    this.active = false;
  }

  saveHandler(objinfo: any) {
    // this.getHeaderGrid();
    //  this.cancelHandler();
    this.dataService.updateAvailableMapping(objinfo, Config.userProfile.personID)
      .subscribe((response: string) => {
        if (response.length !== null) {
          this.getHeaderGrid();
          // this.display = false;
          this.frameworkService.showSuccessMessage('Saved successfully');
        }
      },
        (err: any) => this.frameworkService.logError(err),
        () => this.frameworkService.logInfo('updateAvailableMapping() retrieved updateExcludeMapping'));
    // this.dataItem = this.mappingTable;

    this.mappingTable = [];
    this.availableTable = [];
    this.active = false;
  }

  onClickExpand(text) {
    if (text === 'Expand All') {
      this.frameworkService.showSpinner();
      for (let i = 0; i < this.headerGrid.length; i++) {
        this.mainheaderGrid.expandRow(i);
      }
      this.frameworkService.hideSpinner();

      this.expandflag = true;
      this.expandBtnText = 'Collapse All';
    } else {
      this.frameworkService.showSpinner();

      for (let i = 0; i < this.headerGrid.length; i++) {
        this.mainheaderGrid.collapseRow(i);
      }
      this.frameworkService.hideSpinner();

      this.expandflag = false;
      this.expandBtnText = 'Expand All';
    }

  }
  public onExcelExport(args: any): void {
    // Prevent automatically saving the file. We will save it manually after we fetch and add the details
    args.preventDefault();
    this.loading = true;
    const Observable = [];
    const mainObservable = [];
    const mObservable = [];
    const mappedObservable = [];
    const workbook = args.workbook;
    const rows = workbook.sheets[0].rows;
    // const count = this.systemratinggrid.length + this.systemdrillgrid.length + 2;
    const headerOptions = rows[0].cells[0];
    rows.splice(0, 0, {
      cells: [
        Object.assign({}, headerOptions, { value: 'Relationship mapping Details' })]
    });

    // for (let idx = 0; idx < this.headerGrid.length; idx++) {
    //   Observable.push(this.headerGrid[idx]);
    // }

    mainObservable.push(this.mainheaderGrid);
    for (let idx = 0; idx < mainObservable.length; idx++) {
      Observable.push(mainObservable[0].data);
    }

    // Fetch the data for all details

    for (let idx = 0; idx < this.mappingDetailsGrid.length; idx++) {
      mappedObservable.push(this.mappingDetailsGrid[idx]);
    }

    // add the detail data to the generated master sheet rows
    //  loop backwards in order to avoid changing the rows index

    for (let idx = Observable[0].data.length - 1; idx >= 0; idx--) {
      const maingridData = (<IRelationshipCodeLineItems>Observable[0].data[idx]);
      this.mappedGriddata = mappedObservable.filter(C => C.mCode === maingridData.mCode);
      if ( this.mappedGriddata.length === 0) {
        rows.splice((idx + 3 ), 0, {
          cells: [
          { value: maingridData.mCode },
          { value: maingridData.mName },
          { value: maingridData.mDescription },
          { value: null },
          { value: null },
          { value: null },
          { value: null }
          ]
        });
      }
      if ( this.roleID !== this.itroleID) {
        for (let sc = this.mappedGriddata.length - 1; sc >= 0; sc--) {
          const mappedGriddetails = (<IRelationshipCodeLineItems>this.mappedGriddata[sc]);
            rows.splice((idx + 3 ), 0, {
              cells: [
              { value: mappedGriddetails.mCode },
              { value: mappedGriddetails.mName },
              { value: mappedGriddetails.mDescription },
              { value: mappedGriddetails.code },
              { value: mappedGriddetails.name },
              { value: mappedGriddetails.description }
              ]
            });
          }
        rows.splice((idx + 2 ), 1, {
          cells: [
          Object.assign({}, headerOptions, { value: this.mcode + 'Code' }),
          Object.assign({}, headerOptions, { value: 'Name' }),
          Object.assign({}, headerOptions, { value: 'Description' }),
          Object.assign({}, headerOptions, { value: this. dcode + 'Code' }),
          Object.assign({}, headerOptions, { value: 'Name' }),
          Object.assign({}, headerOptions, { value: 'Description' })
          ]
        });
      } else {
        for (let sc = this.mappedGriddata.length - 1; sc >= 0; sc--) {
          const mappedGriddetails = (<IRelationshipCodeLineItems>this.mappedGriddata[sc]);
            rows.splice((idx + 3 ), 0, {
              cells: [
              { value: mappedGriddetails.mCode },
              { value: mappedGriddetails.mName },
              { value: mappedGriddetails.mDescription },
              { value: mappedGriddetails.code },
              { value: mappedGriddetails.name },
              { value: mappedGriddetails.description },
              { value: mappedGriddetails.isPublishedStatus }
              ]
            });
          }
        rows.splice((idx + 2 ), 1, {
          cells: [
          Object.assign({}, headerOptions, { value: this.mcode + 'Code' }),
          Object.assign({}, headerOptions, { value: 'Name' }),
          Object.assign({}, headerOptions, { value: 'Description' }),
          Object.assign({}, headerOptions, { value: this. dcode + 'Code' }),
          Object.assign({}, headerOptions, { value: 'Name' }),
          Object.assign({}, headerOptions, { value: 'Description' }),
          Object.assign({}, headerOptions, { value: 'Published' })
          ]
        });
      }
      // rows.splice(idx + 2, 0, {
      //   cells: [
      //     { value: maingridData.code },
      //     { value: maingridData.name },
      //     { value: maingridData.description }
      //   ]
      // });

      // rows.splice(idx + 2, 1, {
      //   cells: [
      //     Object.assign({}, headerOptions, { value: 'Code' }),
      //     Object.assign({}, headerOptions, { value: 'Name' }),
      //     Object.assign({}, headerOptions, { value: 'Description' })
      //   ]
      // });
    }
    rows.splice(1, 1);
    new Workbook(workbook).toDataURL().then((dataUrl: string) => {
      saveAs(dataUrl, 'Relationship.xlsx');
      this.loading = false;
    });
  }
  exportToExcel(headerGrid: GridComponent): void {
    headerGrid.saveAsExcel();
  }
}


